export const BASE_PARAMS = {
    domain: {
        name: 'foxes'
    },
    publisher: {
        domain: 'buyers',
        sub_domain: 'foxes'
    },
    feature: {
        name: 'collections_events'
    }
};
